// LWI-1586 — filled Material icons (design system SidebarNav / Iconography),
// sized and tinted by SidebarNavListItem (icon-md, sidebar text at 50%).
import {
  AssignmentTurnedIn,
  Build,
  Description,
  FactCheck,
  Help,
  LocalShipping,
  Map as MapIcon,
  MenuBook,
  NotificationsActive,
  PieChart,
  Receipt,
  Settings,
  ShoppingCart,
  Speed,
  SyncAlt,
} from "@mui/icons-material";

const pagesSection = [
  {
    href: "/shipments/inbound",
    icon: ShoppingCart,
    title: "ISR",
    permissions: ["isr.view"],
  },
  {
    href: "/outbound/msr",
    icon: Speed,
    title: "MSR",
    permissions: ["msr.view"],
  },
  {
    href: "/outbound/sales-orders",
    icon: Receipt,
    title: "Sales Orders",
    permissions: ["so.view"],
  },
  {
    href: "/outbound/deliveries",
    title: "Deliveries",
    icon: LocalShipping,
    permissions: ["deliveries.view"],
  },
  {
    href: "/locations",
    icon: MapIcon,
    title: "Locations Manager",
    permissions: ["locations.view"],
  },
  {
    href: "/customs",
    icon: AssignmentTurnedIn,
    title: "Customs",
    permissions: ["customs.view"],
    children: [
      {
        href: "/customs",
        title: "Dashboard",
      },
    ],
  },
  {
    href: "/supplier-cci",
    icon: FactCheck,
    title: "Supplier CCI",
    permissions: ["cci.view"],
  },
  {
    href: "/licence-control",
    icon: Description,
    title: "Licence Control",
    // Parent shows when the user holds any one of the sub-area view perms.
    permissions: [
      "lcs_po.view",
      "lcs_program.view",
      "lcs_license.view",
      "lcs_eccn.view",
      "lcs_usml.view",
      "lcs_supplier.view",
    ],
    children: [
      {
        href: "/licence-control/purchase-orders",
        title: "Purchase Orders",
        permissions: ["lcs_po.view"],
      },
      {
        href: "/licence-control/programs",
        title: "Programs",
        permissions: ["lcs_program.view"],
      },
      {
        href: "/licence-control/licenses",
        title: "Licenses",
        permissions: ["lcs_license.view"],
      },
      {
        href: "/licence-control/eccn",
        title: "ECCN",
        permissions: ["lcs_eccn.view"],
      },
      {
        href: "/licence-control/usml",
        title: "USML",
        permissions: ["lcs_usml.view"],
      },
      {
        href: "/licence-control/cdn-suppliers",
        title: "Suppliers",
        permissions: ["lcs_supplier.view"],
      },
      {
        // LWI-1165 — shares the lcs_supplier permissions for now.
        href: "/licence-control/consignees",
        title: "Consignees",
        permissions: ["lcs_supplier.view"],
      },
    ],
  },
  {
    href: "/parts",
    icon: Build,
    title: "Parts Manager",
    permissions: ["parts.view"],

    children: [
      {
        href: "/parts",
        title: "Dashboard",
      },
      {
        href: "/parts/classifications",
        title: "Classification List",
      },
    ],
  },
  // {
  //   href: "/logikmap",
  //   icon: ShoppingCart,
  //   title: "LOGIKmap",
  //   disabled: true,
  //   permissions: ["logikmap:read"],
  // },
  {
    href: "/integration",
    icon: SyncAlt,
    title: "Integration Monitor",
    permissions: ["monitor.view"],

    children: [
      {
        href: "/integration/dashboard",
        title: "Dashboard",
        disabled: true,
      },
      {
        
        href: "/integration/import-monitor",
        title: "Oracle EDI",
      },
      {
        href: "/integration/api",
        title: "Logikor API",
        disabled: true,
      },
    ],
  },
  {
    href: "/analytics",
    icon: PieChart,
    title: "Analytics",
    // Parent shows when the user can see at least one analytics page.
    permissions: [
      "analytics.mia_trends.view",
      "analytics.mia_status.view",
      "analytics.control_tower.view",
    ],
    children: [
      {
        href: "/analytics/mia-trends",
        title: "MIA Trends",
        permissions: ["analytics.mia_trends.view", "analytics.mia_status.view"],
      },
      {
        href: "/analytics/control-tower",
        title: "Control Tower",
        permissions: ["analytics.control_tower.view"],
      },
    ],
  },
  {
    href: "/luna",
    icon: NotificationsActive,
    title: "LUNA",
    // Parent shows when the user can see at least one child.
    permissions: ["notifications.view", "report.view"],
    children: [
      {
        href: "/notifications",
        title: "Dashboard",
        permissions: ["notifications.view"],
      },
      {
        href: "/report-builder",
        title: "Report Builder",
        permissions: ["report.view"],
      },
    ],
  },
  {
    href: "/knowledge-base",
    icon: MenuBook,
    title: "Knowledge Base",
    permissions: ["kb.view"],
  },
  {
    href: "/admin",
    icon: Settings,
    title: "Administration",
    // Parent shows when the user can see any admin sub-area.
    permissions: [
      "users.view",
      "roles.view",
      "users.lockouts.view",
      "mia_exception.view",
      "mia.view",
      "program.view",
      "shipment_admin.view",
      "area_manager.view",
      "oracle_location.view",
      "audit.view",
    ],
    children: [
      {
        href: "/admin/users",
        title: "User Management",
        permissions: ["users.view"],
      },
      {
        href: "/admin/roles",
        title: "Role Management",
        permissions: ["roles.view"],
      },
      {
        href: "/admin/account-lockouts",
        title: "Account Lockouts",
        permissions: ["users.lockouts.view"],
      },
      {
        href: "/admin/audit-log",
        title: "Audit Log",
        permissions: ["audit.view"],
      },
      {
        href: "/admin/my-exceptions",
        title: "Exceptions",
        permissions: ["mia_exception.view"],
      },
      // LWI-916 — MIA Reasons is no longer a top-level sidebar item. It now
      // appears as a row inside the Shipment Management dropdown-fields
      // table (clicking Details navigates to the existing /admin/mia
      // editor, which is still gated on `mia.view`).
      {
        href: "/admin/projects",
        title: "Programs/Projects",
        permissions: ["program.view"],
      },
      {
        href: "/admin/shipmentmanagement",
        title: "Shipment Management",
        permissions: ["shipment_admin.view"],
      },
      {
        href: "/admin/area-managers",
        title: "Area Managers",
        permissions: ["area_manager.view"],
      },
      {
        href: "/admin/oracle-locations",
        title: "Oracle Locations",
        permissions: ["oracle_location.view"],
      },

      // {
      //   href: "/admin/equivalency",
      //   title: "Equivalency Table",
      //   disabled: true,
      // },
    ],
  },
  {
    href: "/support",
    icon: Help,
    title: "Support",
    permissions: ["faq.view", "glossary.view"],
    children: [
      {
        href: "/support/faq",
        title: "FAQ",
        permissions: ["faq.view"],
      },
      {
        href: "/support/glossary",
        title: "Glossary of Terms",
        permissions: ["glossary.view"],
      },
      {
        href: "/support/workflows",
        title: "Workflows",
        disabled: true,
      },
      {
        href: "/support/chat",
        title: "Chat",
        disabled: true,
      },
      {
        href: "/support/contact",
        title: "Contact Details",
        disabled: true,
      },
    ],
  },
];

const navItems = [
  {
    title: "Pages",
    pages: pagesSection,
  },
];

export default navItems;
